import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  GroupComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
  ProviderItemComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-current-user-profile-companies-item',
  templateUrl: './current-user-profile-companies-item.component.html',
  styleUrls: ['./current-user-profile-companies-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProviderItemComponent,
    HeadingComponent,
    NgTemplateOutlet,
    TranslatePipe,
    IconComponent,
    GroupComponent,
    ButtonComponent,
    IconButtonComponent,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    TruncateComponent,
  ],
})
export class CurrentUserProfileCompaniesItemComponent {
  public signedIn = input<boolean>(false);
  public isOwner = input<boolean>(false);
  public companyName = input.required<string>();

  public leaveCompany = output<void>();
  public signIn = output<void>();

  public DropdownWidth = DropdownWidth;
}
